import { render, staticRenderFns } from "./editReminder.vue?vue&type=template&id=1691d806&"
import script from "./editReminder.vue?vue&type=script&lang=js&"
export * from "./editReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports